import { Subscribe } from "@/utils/subscribe";

export interface PageEvent {
  page_load: string;
  page_close: string;
  page_click: PointerEvent;
  message: MessageEvent["data"];
  track: "form" | "tel" | "human";
}
export const $event_subscribe = new Subscribe<PageEvent>();
